import { Link } from "react-router-dom";
import { EmptyState, ProductCard, Skeleton } from "@aurelia/ui";
import { useWishlist, useToggleWishlist } from "../../features/wishlist/queries";
import { useDocumentMeta } from "../../lib/useDocumentMeta";

export function WishlistPage() {
  useDocumentMeta("Wishlist", "Products you've saved for later.", undefined, undefined, { noindex: true });
  const { data, isLoading, isError } = useWishlist();
  const toggleWishlist = useToggleWishlist();

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="aspect-square" />
        ))}
      </div>
    );
  }

  if (isError) {
    return (
      <EmptyState tone="error" title="Couldn't load your wishlist" description="Please refresh and try again." />
    );
  }

  if (!data || data.length === 0) {
    return (
      <EmptyState
        title="Nothing saved yet"
        description="Tap the heart on any product to save it here for later."
        action={
          <Link
            to="/"
            className="mt-1 inline-flex items-center h-11 px-6 rounded-full bg-ink text-canvas text-sm font-medium hover:bg-accent hover:text-ink transition-colors duration-300 dark:bg-accent dark:text-ink"
          >
            Discover products
          </Link>
        }
      />
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
      {data.map((p) => (
        <ProductCard
          key={p.id}
          slug={p.slug}
          name={p.name}
          shortDescription={p.shortDescription}
          imageUrl={p.images[0] ?? null}
          basePrice={p.basePrice}
          compareAtPrice={p.compareAtPrice}
          soldCount={p.soldCount}
          stock={p.variants.reduce((sum, v) => sum + v.stock, 0)}
          wishlisted
          onToggleWishlist={() => toggleWishlist.mutate(p.id)}
        />
      ))}
    </div>
  );
}
